import styledMUI from '@emotion/styled'
import MuiAppBar from '@mui/material/AppBar'
import { Typography } from '@mui/material'
// import { styled } from 'styled-components'
import { Link } from 'react-router-dom'

export const drawerWidth = 260

export const Main = styledMUI('main', {
  shouldForwardProp: (prop) => prop !== 'menuOpen',
})(({ theme, menuOpen }: { theme?: any; menuOpen: boolean }) => ({
  flexGrow: 1,
  padding: theme.spacing(14),
  transition: theme.transitions.create('margin', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  marginLeft: `-${drawerWidth}px`,
  ...(menuOpen && {
    transition: theme.transitions.create('margin', {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    marginLeft: 0,
  }),
}))

export const AppBar = styledMUI(MuiAppBar, {
  shouldForwardProp: (prop) => prop !== 'menuOpen',
})(({ theme, menuOpen }: { theme?: any; menuOpen: boolean }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  width: '100%',

  svg: {
    cursor: 'pointer',
  },

  transition: theme.transitions.create(['margin', 'width'], {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  ...(menuOpen && {
    width: `calc(100% - ${drawerWidth}px)`,
    marginLeft: `${drawerWidth}px`,
    transition: theme.transitions.create(['margin', 'width'], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
  }),
}))

export const DrawerHeader = styledMUI('div')(({ theme }: { theme?: any }) => ({
  display: 'flex',
  alignItems: 'center',
  flexDirection: 'column',
  width: '100%',
  padding: '0 14px',
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'space-between',
  img: {
    marginRight: 10,
  },
  p: {
    fontWeight: 500,
    size: 14,
    color: '#E5E5E5',
  },

  marginBottom: 15,
}))

export const LogoHeader = styledMUI('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginTop: '10px',
}))

export const ContainerLogo = styledMUI('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  width: '100%',
}))

export const ContainerSearch = styledMUI('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-start',
  width: '100%',
  input: {
    color: '#fff',
    border: 0,
    fontWeight: 500,
    fontSize: 14,
    backgroundColor: '#333333',
  },
}))

export const ListItemsMenu = styledMUI('div')({
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  overflowY: 'auto',
});

export const Subjects = styledMUI('div')({
  display: 'flex',
  padding: '0 16px',
  justifyContent: 'space-between',
  p: {
    color: 'var(--global-grey-20, #EBEDF5)',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
})

export const ContainerList = styledMUI('div')({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  height: 'calc(100% - 130px)',
  justifyContent: 'space-between',
})

export const PathLink = styledMUI(Link)<{ selected?: boolean }>`
  display: flex;
  font-size: 14px;
  color: #3baab0;
  cursor: pointer;
  margin-right: 10px;
  align-items: center;
  margin: 0px;
  text-decoration: none;
  font-family: Roboto;
  font-size: 14px;
  font-style: normal;
  font-weight: 300;
  line-height: 20px;
  letter-spacing: 0.28px;
  svg {
    margin-left: '5px';
  }
`

export const PathElem = styledMUI.p<{ selected?: boolean }>`
  cursor: pointer;
  display: flex;
  align-items: center;
  color: #808080;
  font-size: 14px;
  margin-right: 10px;
  svg {
    margin-left: '5px';
  }
`

export const PathContainer = styledMUI('div')(() => ({
  display: 'flex',
  alignItems: 'center',
}))
export const PathArrowContainer = styledMUI('div')(() => ({
  display: 'flex',
  alignItems: 'center',
  marginRight: '10px',
  svg: {
    cursor: 'pointer',
  },
}))
export const TextContainer = styledMUI('div')({
  display: 'flex',
  alignItems: 'flex-end',
  flexDirection: 'column',
  marginRight: '10px',
  p: {
    marginRight: '5px',
  },
  div: {
    display: 'flex',
  },
})

export const ProfileContainer = styledMUI.div`
  /* height: fit-content; */
  display: flex;
  align-items: center;
  width: 80%;
  > div {
    width: 95%;
  }
  span {
    cursor: pointer;
    background: transparent;
    border: none;
  }
`

export const TypographyPopover = styledMUI(Typography)(() => ({
  cursor: 'pointer',

  ':hover': {
    color: '#fff',
    background: '#333',
  },
}))
